import React, { Suspense } from "react";
import { BrowserRouter } from "react-router-dom";
import { SWRConfig } from "swr";
import { ThemeProvider } from "lib/context/ThemeContext";
import {
  EmbeddedAppProps,
  EmbeddedProvider,
} from "lib/context/EmbeddedContext";
import { StandaloneProvider } from "lib/context/StandaloneContext";
import { NavigationProvider } from "lib/context/NavigationContext";
import { NotificationProvider } from "lib/context/NotificationContext";
import { MapProvider } from "lib/context/MapContext";
import navigation from "lib/navigation";
import Routes from "lib/routes";

import { fetcher } from "lib/api/axiosWIS";
import "lib/i18n";
import NotAllowed from "pages/NotAllowed";
import { UserDataProvider } from "lib/context/UserDataContext";
import "./LeafletFix.css";

const App: React.FC<EmbeddedAppProps> = (props) => {
  const isEmbedded = !!props?.container;
  const production = process.env.NODE_ENV === "production";
  const showNotAllowedError = production && !isEmbedded;

  if (showNotAllowedError) {
    return (
      <Suspense fallback={<></>}>
        <ThemeProvider>
          <NotAllowed />
        </ThemeProvider>
      </Suspense>
    );
  }

  return (
    <Suspense fallback={<></>}>
      <BrowserRouter basename={props?.basename || "/"}>
        <ThemeProvider>
          <NotificationProvider>
            <NavigationProvider navigation={navigation}>
              <MapProvider>
                <SWRConfig
                  value={{
                    suspense: true,
                    // default fetcher is for WIS backend
                    fetcher,
                  }}
                >
                  {isEmbedded ? (
                    <EmbeddedProvider {...props}>
                      <UserDataProvider policies={props.userOperations}>
                        <Routes />
                      </UserDataProvider>
                    </EmbeddedProvider>
                  ) : (
                    <StandaloneProvider>
                      <UserDataProvider policies={props.userOperations}>
                        <Routes />
                      </UserDataProvider>
                    </StandaloneProvider>
                  )}
                </SWRConfig>
              </MapProvider>
            </NavigationProvider>
          </NotificationProvider>
        </ThemeProvider>
      </BrowserRouter>
    </Suspense>
  );
};

export default App;
